module.exports = __webpack_public_path__ + "static/media/lendas-colecionaveis.4e07fae2.png";